import { render, staticRenderFns } from "./PickupLocationEditCard.vue?vue&type=template&id=74c8080a&scoped=true&"
import script from "./PickupLocationEditCard.vue?vue&type=script&lang=js&"
export * from "./PickupLocationEditCard.vue?vue&type=script&lang=js&"
import style0 from "./PickupLocationEditCard.vue?vue&type=style&index=0&id=74c8080a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c8080a",
  null
  
)

export default component.exports